import type { NodeRenderer } from '../generateNodes';
import type { ScrollViewNode } from '../schema';
import styles from './renderers.module.css';

const DEFAULT_MAX_BLOCK_SIZE = 300;

export const ScrollViewRenderer: {
  scrollview: NodeRenderer<ScrollViewNode>;
} = {
  scrollview: ({ node, nodesToJSX }) => {
    const maxBlockSize =
      node.attributes?.maxBlockSize ?? DEFAULT_MAX_BLOCK_SIZE;
    return (
      <div className={styles.scrollview} style={{ maxHeight: maxBlockSize }}>
        {nodesToJSX({ nodes: node.children })}
      </div>
    );
  },
};
